import { Pipe, PipeTransform } from '@angular/core';

import { UnidadeNegocioNaturezaVenda } from '../unidade-negocio-natureza-venda';

@Pipe({
    name: 'unidadeNegocioNaturezaVendaFilter',
    pure: false
})
export class UnidadeNegocioNaturezaVendaFilterPipe implements PipeTransform {
    /** Filtra as naturezas de vendas pelas unidades de negócios informadas informadas */
    transform(entities: UnidadeNegocioNaturezaVenda[], idsUnidadesNegocios: number[] = []): UnidadeNegocioNaturezaVenda[] {
        if (!entities) {
            return [];
        }
        // Retorna todas as naturezas de vendas quando não for informada nenhuma unidade de negócio para filtar
        if (!idsUnidadesNegocios || idsUnidadesNegocios.length === 0) {
            return entities;
        }

        return entities.filter(entityFilter =>  idsUnidadesNegocios.includes(entityFilter.idUnidadeNegocio));
    }
}
